// src/components/audition-booking-wizard/utils/bookingHelpers.js

// Constants for Booking Wizard steps
export const WIZARD_STEPS = (selectedMode) => {
    // Dynamically adjust steps based on selectedMode
    const baseSteps = ['Mode', 'Pay', 'Script'];
    const finalSteps = ['Details']; // 'Audition Details' renamed to 'Details' for brevity

    if (selectedMode === 'ONLINE') {
        return [...baseSteps, 'Upload', ...finalSteps]; // Add 'Upload' step for online
    }
    return [...baseSteps, ...finalSteps]; // No 'Upload' step for F2F/Walk-in
};

// Image assets (if you prefer them outside the component)
export const bookImg = "https://bookmyaudition.com/theme/theme3/vendors/images/booking_page_icon/book_xs.png";
export const prepareImg = "https://bookmyaudition.com/theme/theme3/vendors/images/booking_page_icon/prepare_xs.png";
export const recordImg = "https://bookmyaudition.com/theme/theme3/vendors/images/booking_page_icon/record_xs.png";
export const uploadImg = "https://bookmyaudition.com/theme/theme3/vendors/images/booking_page_icon/upload_xs.png";

export const JOGET_BASE_URL = "https://bma.on.joget.cloud";